import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export interface ReviewSubmittedConfirmationProps {
  title?: string;
  description?: string;
}

const ReviewSubmittedConfirmation: React.FC<ReviewSubmittedConfirmationProps> = ({ title, description }) => {
  return (
    <div className="relative flex min-h-[644px] w-full max-w-[540px] flex-col justify-center gap-32 bg-white px-32 py-34 lg:min-h-0">
      <div className="flex flex-col items-center justify-center gap-24">
        <CheckCircleIcon className="h-56 w-56 text-feedback-success" />
        {title && <h2 className="body-text-2xlarge text-center font-bold">{title}</h2>}
        {description && <p className="body-text text-center text-text-primary">{description}</p>}
      </div>
    </div>
  );
};

export default ReviewSubmittedConfirmation;
